import { Breadcrumb, Button, Col, Form, Input, Row, Select } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import editProfile from "../../assets/images/icon/editProfile.svg";
import SuccessIcon from "../../assets/images/icon/successIcon.svg";
import Heading from "../../components/common/heading";
import Previous from "../../components/common/previous";
import { ERR_0051, USER_DATA } from "../../lib/const";
import useAuth from "../../lib/hooks/useAuth";
import useCancelModal from "../../lib/hooks/useCancelModal";
import useEState from "../../lib/hooks/useEState";
import useLineOfWork from "../../lib/hooks/useLineOfWork";
import { routes } from "../../routes";
import { getProfile, updateProfile } from "../../services/profileService";
import WithSidebar from "../../templates/withSidebar";
import { Tree } from "react-arborist";
import useListOrgChartVerList from "../../lib/hooks/useListOrgChartVerList";
import useListOrgChartDataList from "../../lib/hooks/useListOrgChartDataList";


const Option = Select.Option;

const OrgChart = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const { auth, setAuth } = useAuth();
  const { setOpenCancelModal } = useCancelModal();
  const [estates] = useEState();
  const [lineOfWork] = useLineOfWork();
  const [submittable, setSubmittable] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [errMsg, setErrMsg] = useState("");
 const [version, setVersion] = useState("");
 const [listOrgChartVerList] = useListOrgChartVerList();
 // const [listOrgChartDataList] = useListOrgChartDataList();
  const [listOrgChartDataList, fetchOrgChartDataList] = useListOrgChartDataList();
  const data = [
  {
    id: "1",
    name: "กนอ.",
    children: [
      { id: "2", 
        name: "สำนักผู้ว่าการ",
        children:[
                {id:"22",name:"กองกลาง"},
                {id:"23",name:"กองสื่อสารองค์กร"},
                {id:"24",name:"กองกิจการคณะกรรมการ"},
                {id:"25",name:"กองกฏหมายและระเบียบ"}
            ] 
      },
      { id: "3", 
        name: "ฝ่ายกฏหมาย",
        children:[
                {id:"31",name:"กองกฏหมายและระเบียบ"},
                {id:"32",name:"กองนิติกรรมและกรรมสิทธิ์ที่ดิน"}
        ]
      },
      { id: "4", 
        name: "ฝ่ายดิจิทัล",
         
      },
      { id: "5", 
        name: "รองผู้ว่าการ(ประจำสำนักผู้ว่าการ)",
        
      },
      { id: "6", 
        name: "รองผู้ว่าการ(บริหาร)",
         
      },
       { id: "7", 
        name: "รองผู้ว่าการ(ยุทธศาสตร์)",
       
      },
      
       { id: "8", 
        name: "รองผู้ว่าการ(พัฒนายั่งยืน)",
       
      },
      ,
      
       { id: "9", 
        name: "รองผู้ว่าการ(ปฏิบัติการ 1)",
        children:[
                
                {id:"91",name:"ฝ่ายอำนวยการปฏิบัติการ 1"},
                {id:"92",name:"กลุ่มสำนักงานนิคมฯ กรุงเทพมหานคร"},
                {id:"93",name:"กลุ่มสำนักงานนิคมฯ พระนครศรีอยุธยา" ,
                    children:[
                    {id:"931",name:"สำนักงานนิคมฯ นครหลวง"},
                    {id:"932",name:"สำนักงานนิคมฯ บางปะอิน"},
                    {id:"933",name:"สำนักงานนิคมฯ บ้านหว้า"},
                     {id:"934",name:"สำนักงานนิคมฯ เอส อ่างทอง"}
                ]}
               
        ]
      }
    ]
  }
];

  const setProfileValues = useCallback(() => {
    let text = auth?.user?.fullName;
    const full_n = text?.split(" ");
    let first_n,
      last_n = "";
    if (full_n) {
      first_n = full_n[0];
      last_n = full_n[1];
    }

    form.setFieldsValue({
      firstName: first_n,
      lastName: last_n,
      email: auth?.user?.email,
      estateId: auth?.user?.estateId,
      lineOfWorkId: auth?.user?.lineOfWorkId,
    });
  }, [form, auth]);

  useEffect(() => {
    setProfileValues();
  }, [setProfileValues]);

  const onFinish = async (values) => {
    const request = {
      userId: auth?.user?.userId,
      username: auth?.user?.username,
      firstname: values.firstName,
      lastname: values.lastName,
      roleId: auth?.user?.roleId,
      email: values.email,
      description: auth?.user?.description,
      estateId: values.estateId,
      lineOfWorkId: values.lineOfWorkId,
      fromPage: "profile",
    };

    const res = await updateProfile(request);
    if (res.data.code === "0000") {
      const resp = await getProfile();
      if (resp.data.code === "0000") {
        const { objectValue } = resp.data;
        setAuth({
          user: objectValue,
          isLogin: true,
        });
        localStorage.setItem(USER_DATA, JSON.stringify(objectValue));
      }
      setUpdateStatus(true);
    } else {
      setUpdateStatus(false);
      if (res?.data?.code === "ERR-9999") {
        setErrMsg("เกิดข้อผิดพลาดภายในเซิร์ฟเวอร์");
      } else if (res?.data?.code === ERR_0051) {
        setErrMsg("ระบบไม่สามารถดำเนินการส่งเมลได้");
      } else {
        setErrMsg("ขออภัย, มีเกิดข้อผิดพลาดบางอย่าง");
      }
    }
  };

  useEffect(() => {
    if (
      values?.firstName === "" ||
      values?.lastName === "" ||
      values?.email === "" ||
      !values?.estateId ||
      !values?.lineOfWorkId
    ) {
      setSubmittable(true);
    } else {
      setErrMsg("");
      setSubmittable(false);
    }
  }, [values, form, submittable]);

  function Node({ node, style }) {
  return (
    <div
      style={{
        ...style,
        cursor: "pointer",
      
      }}
      onClick={() => node.toggle()}
    >
          <div style={style}>
          {node.isLeaf ? "📄" : "📁"} {node.data.name}
        </div>

      {" "}
     
    </div>
  );
}
  return (
    <WithSidebar>
      <Row gutter={[16]}>
        
        <Col span={24}>
          <Previous text={"แสดงผังองค์กร"} prevLink={routes.dashboard} />
          <Breadcrumb
            style={{ paddingTop: 10 }}
            items={[
              {
                title: "Dashboard",
              },
              {
                title: <span className="pr_green">แสดงผังองค์กร</span>,
              },
            ]}
          />
        </Col>
      </Row>
       <Row>
        <Col span={24}>&nbsp;</Col>
        </Row>
         <Row>
        <Col span={8}>
         <Select
                          allowClear
                          style={{
                            width: "100%",
                          }}
                          placeholder="กรุณาเลือก"
                          onChange={(value) => {
                            if (value) {
                              setVersion(value);
                            //  alert("onchange="+value);
                              fetchOrgChartDataList(value);
                            }
                          }}
                        >
                          {listOrgChartVerList.map((item) => (
                            <Option key={item.orgChartVerId} value={item.orgChartVerText}>
                              {item.orgChartVerId}
                            </Option>
                          ))}
                        </Select>
        </Col>
        </Row>
        <Row>
        <Col span={24}>&nbsp;</Col>
        </Row>
      <Row>
        <Col span={4}></Col>
         <Col span={16}>
         <Tree
      // initialData={data}
      data={listOrgChartDataList}
      width={400}
      height={800}
      rowHeight={32}
    >
       
       {Node}
    </Tree>
         </Col>
         <Col span={4}></Col>
      </Row>
      <div>
 

      </div>
       
    </WithSidebar>
  );
};

export default OrgChart;
